import { RestService } from './restService';
import { DashboardData } from '../models';

export class DashboardService extends RestService<DashboardData> {
    public constructor(baseUrl: string, baseRoute: string) {
        super(baseUrl, baseRoute);
    }
}
